import React, {createContext, useReducer} from 'react'
import {VirtualDepartDriverReducer} from "../reducer/VirtualDepartDriverReducer";

export const VirtualDepartDriverContext = createContext();

export const virtualDepartDriverInitialState = {
    isLoading: false,
    requestCompleted: false,
    errorMessage: "",
    message: "",
    type: ""
};

const VirtualDepartDriverContextProvider = (props) => {

    const [virtualDepartDriverModel, virtualDepartDriverDispatch] = useReducer(VirtualDepartDriverReducer, virtualDepartDriverInitialState)
    return (
        <VirtualDepartDriverContext.Provider value={{virtualDepartDriverModel, virtualDepartDriverDispatch}}>
            {props.children}
        </VirtualDepartDriverContext.Provider>
    )
}

export default VirtualDepartDriverContextProvider



// WEBPACK FOOTER //
// ./src/components/virtualDepartDriver/context/VirtualDepartDriverContext.js